export default [
  {
    component: () => import('./Admin.vue'),
    children: [
      {
        name: 'AdminHome',
        path: '/admin',
        component: () => import('./content/AdminHome.vue'),
        meta: {
          title: 'Administração',
        },
      },
      {
        name: 'AdminUsers',
        path: '/admin/users',
        component: () => import('./content/AdminUsers.vue'),
        meta: {
          title: 'Lista de Usuários',
        },
      },
      {
        name: 'AdminUsersEdit',
        path: '/admin/users/:userId',
        props: true,
        component: () => import('./content/AdminUsersEdit.vue'),
        meta: {
          title: 'Dados do Usuário',
        },
      },
      {
        name: 'AdminFlows',
        path: '/admin/flows',
        component: () => import('./content/AdminFlows.vue'),
        meta: {
          title: 'Fluxos',
        },
      },
      {
        name: 'AdminActivities',
        path: '/admin/activities',
        component: () => import('./content/AdminActivities.vue'),
        meta: {
          title: 'Atividades',
        },
      },
    ],
  },
];
